import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function InvestmentBenefits() {
  return (
    <section id="invest" className="py-16 px-6 bg-navy-900">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-xs font-medium text-green-400 uppercase tracking-wider">
            Investment Benefits
          </span>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-thin text-white mt-4 mb-3 leading-tight">
            Accelerated Depreciation
            <span className="inline-flex items-center mx-2">
              <span className="relative w-20 h-12 md:w-24 md:h-14 rounded-full overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/7238f59951d8b0bb8d625d0f2e9c57c3.jpg"
                  alt="Depreciation"
                  className="w-full h-full object-cover object-center"
                />
              </span>
            </span>
          </h2>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-thin text-white mb-3 leading-tight">
            for Maximum Tax Benefits
          </h2>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-thin text-white mb-8 leading-tight flex flex-wrap items-center gap-2">
            Consistent Revenue
            <span className="inline-flex items-center">
              <span className="relative w-20 h-12 md:w-24 md:h-14 rounded-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Business%20revenue%20growth%20chart%20with%20blue%20gradient%20colors%2C%20upward%20trending%20financial%20graph%20visualization%2C%20clean%20minimalist%20background%2C%20modern%20data%20analytics%20aesthetic%2C%20professional%20business%20illustration%20style&width=400&height=240&seq=invest-revenue-002&orientation=landscape"
                  alt="Revenue Graph"
                  className="w-full h-full object-cover object-center"
                />
              </span>
            </span>
            from Advertising Income
            <span className="inline-flex items-center">
              <span className="relative w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Golden%20coins%20stack%20on%20clean%20simple%20background%2C%20wealth%20and%20investment%20concept%2C%20minimalist%20financial%20illustration%2C%20warm%20gold%20tones%2C%20professional%20business%20photography%20style&width=200&height=200&seq=invest-coins-003&orientation=squarish"
                  alt="Coins"
                  className="w-full h-full object-cover object-center"
                />
              </span>
            </span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="mt-10 text-center"
        >
          <Link
            to="/en/simulator#simulator"
            className="inline-flex items-center gap-2 px-6 py-3 bg-amber-500 text-black font-semibold text-sm rounded-full hover:bg-amber-400 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calculator-line text-lg"></i>
            Calculate Your ROI
            <i className="ri-arrow-right-line"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
